module.exports = __webpack_public_path__ + "img/loading.4bb1b6f5.png";